export interface IconProps {
  active: boolean;
  className?: string;
  disabled?: boolean;
  tooltip?: string;
  isError?: boolean;
  toggleTooltip?: (value: React.SetStateAction<boolean>) => void;
}

export const circleColor = (active: boolean): string =>
  active ? '#4B4B4B' : '#29335C';

export const strokeColor = (active: boolean): string =>
  active ? '#CDD5E5' : '#FFFF';
